import "Feature/SimpleLanguage/code/Styles/simpleLanguageSearchHeaderNavigation.scss"

window.am = window.am || {};

window.am.simpleLanguageSearchHeaderNavigation = new function () {
    const init = () => {
        const navMobileHeaderElement = document.querySelector('.nav-mobile-header');
        const sourceSearchElement = document.querySelector('.metanav__right .metanav__search');

        if (!navMobileHeaderElement || !sourceSearchElement) {
            return;
        }

        navMobileHeaderElement.appendChild(sourceSearchElement.cloneNode(true));
    };

    return {
        init: init
    };
};

window.addEventListener('load', window.am.simpleLanguageSearchHeaderNavigation.init);